<template>
  <el-switch v-model="valueData" @change="notifyChange_2"/>
</template>

<script>
export default {
    name : 'UserNotifyConfigSwitch',

    props: ['value', 'eventType', 'notifyType'],

    data() {
        return {
            valueData: null
        }
    },

    mounted() {
        this.valueData = this.value;
    },

    watch: {
        value() {
            this.valueData = this.value;
        }
    },

    methods: {
        notifyChange_2() {
            this.$emit('update', {
                eventType: this.eventType,
                notifyType: this.notifyType,
                open: this.valueData
            });
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ticket/UserNotifyConfigSwitch.vue